import $ from 'jquery';

class HeaderHightlight {
    constructor() {
        this.$area = $('.header-highlight');
        this.$activeArea = $('.header-highlight-area').length ? $('.header-highlight-area') : $('.header-highlight');
        this.$heading = this.$area.find('.header-highlight-text');
        this.$parent = this.$heading.parent();
        this.color = this.$area.data('highlight-color') || '#000';
        this.mouseX = 0;
        this.mouseY = 0;

        this.render();
        this.events();
    }

    events() {
        this.$activeArea.one('mousemove', (e) => {
            this.bulb.$node.addClass('moved');
            this.force(e.pageX, e.pageY);
        });
        this.$activeArea.on('mousemove', e => {
            this.updatePosition(e.pageX, e.pageY);
        });
    }

    render() {
        this.bulb = {
            $node: $('<div />'),
            angle: 0,
            speed: 0.035,
            position: {x: 0, y: 0},
            shift: {x: 0, y: 0}
        };

        this.$parent.wrapInner($('<div class="header-highlight-background" />'));
        this.$parent.wrapInner($('<div class="header-highlight-wrapper" />'));
        this.bulb.$node
            .addClass('header-highlight-bulb')
            .css({
                backgroundColor: this.color,
                boxShadow: `${this.color} 0 0 40rem 30rem`
            })
            .appendTo($('.header-highlight-wrapper'))
            .wrap($('<div class="header-highlight-bulb-wrapper" />'));

        setInterval(() => {
            this.refresh();
        }, 1000 / 60);
    }

    refresh() {
        let x,
            y;

        this.bulb.angle += this.bulb.speed;

        this.bulb.shift.x += (this.mouseX - this.bulb.shift.x) * (this.bulb.speed);
        this.bulb.shift.y += (this.mouseY - this.bulb.shift.y) * (this.bulb.speed);

        this.bulb.position.x = this.bulb.shift.x + Math.cos(this.bulb.angle) - this.$parent.offset().left;
        this.bulb.position.y = this.bulb.shift.y + Math.sin(this.bulb.angle) - this.$parent.offset().top;

        x = this.bulb.position.x - this.bulb.$node.width() / 2;
        y = this.bulb.position.y - this.bulb.$node.height() / 2;

        this.bulb.$node.css('transform', `translate3d(${x}px, ${y}px, 0)`);
    }

    updatePosition(x, y) {
        this.mouseX = x;
        this.mouseY = y;
    }

    force(x, y) {
        let speedSave = this.bulb.speed;

        this.bulb.speed = 1;
        this.updatePosition(x, y);
        this.refresh();
        this.bulb.speed = speedSave;
    }
}

export default HeaderHightlight;



// WEBPACK FOOTER //
// ./sources/js/components/header-highlight.js